import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons/faEllipsisV';
import Font from '@maxpreps/shared/styles/font';
import React from 'react';
import styled from 'styled-components';
import useHasMounted from '../../../hooks/useHasMounted';
import { COLOR } from '../../../styles/colors';
import Icon from '../../../ui/Icon/Icon';
import Anchor from '../../Anchor/Anchor';
import useSiteNavContext from '../SiteNavContext';
import { getMainSportLinksData, getMoreSportsData } from '../SiteNavUtils';
import DualSportDropdown from './DualSportDropdown';
import SingleSportDropdown from './SingleSportDropdown';

const StyledSportLinksList = styled.ul<{ $isVisible: boolean }>`
  display: ${({ $isVisible }) => ($isVisible ? 'flex' : 'none')};
  align-items: center;
  height: 100%;
`;

const StyledMenuListItem = styled.li`
  margin-left: 24px;
  margin-bottom: 4px;
  height: 100%;
  position: relative;

  display: flex;
  align-items: center;

  & > a {
    height: 100%;
    line-height: 52px;
    &.more-sports {
      padding: 8px;
      display: flex;
      align-items: center;
    }
  }
`;

const MoreSportsListItem = () => {
  const { siteNavData, activeNavId, setActiveNavId, clearActiveNavId } =
    useSiteNavContext();

  const moreSportsData = getMoreSportsData(siteNavData);
  const { id, href, leftItems, rightItems } = moreSportsData;

  const isOpen = activeNavId === id;
  const isDimmed = !isOpen && activeNavId !== null;
  return (
    <StyledMenuListItem
      key="more"
      onMouseEnter={() => setActiveNavId(id)}
      onMouseLeave={clearActiveNavId}
    >
      <Anchor
        href={href}
        $color={isDimmed ? `${COLOR.white}7F` : COLOR.white}
        className="more-sports"
      >
        <Icon icon={faEllipsisV} rotation={90} size={24} />
      </Anchor>
      {isOpen && (
        <DualSportDropdown
          leftItems={leftItems}
          rightItems={rightItems}
          allSportsLink={href}
        />
      )}
    </StyledMenuListItem>
  );
};

const SportLinksList: React.FC<{ isVisible: boolean }> = ({ isVisible }) => {
  const { siteNavData, setActiveNavId, clearActiveNavId, activeNavId } =
    useSiteNavContext();

  const menuItems = getMainSportLinksData(siteNavData);
  const hasMounted = useHasMounted();

  return (
    <StyledSportLinksList className={Font.f16_bold_tall} $isVisible={isVisible}>
      {menuItems.map(item => {
        const { id, text, href, subItems } = item;
        const isOpen = activeNavId === item.id;
        const isDimmed = !isOpen && activeNavId !== undefined;
        return (
          <StyledMenuListItem
            key={id}
            onMouseEnter={() => setActiveNavId(id)}
            onMouseLeave={clearActiveNavId}
          >
            <Anchor
              href={href}
              $color={isDimmed ? `${COLOR.white}7F` : COLOR.white}
            >
              {text}
            </Anchor>
            {(isOpen || !hasMounted) && (
              <SingleSportDropdown subItems={subItems}>
                {text}
              </SingleSportDropdown>
            )}
          </StyledMenuListItem>
        );
      })}
      <MoreSportsListItem />
    </StyledSportLinksList>
  );
};

export default SportLinksList;
